<template>
  <div class="report-editor">
    <div class="page_title flex_between">
      <span>{{ reportRoute.report_id | titleText }}</span>

      <el-button type="primary"
                 style="width: 92px"
                 size="medium"
                 @click="back">返回</el-button>
    </div>

    <div class="container">
      <div class="report-box">
        <el-form :model="reportEditorForm"
                 :rules="rules"
                 ref="reportEditorFormRef"
                 label-width="100px"
                 class="report-reportEditorForm">
          <el-form-item label="报表名称:"
                        prop="report_name">
            <el-input v-model="reportEditorForm.report_name"
                      :disabled="isDisable"></el-input>
          </el-form-item>

          <el-form-item label="类别:"
                        prop="type"
                        class="report-type">
            <el-radio-group v-model="reportEditorForm.type"
                            :disabled="isDisable">
              <el-radio :label="'1'">原生</el-radio>
              <el-radio :label="'2'">H5</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="路由名称:"
                        prop="route_url">
            <el-input v-model="reportEditorForm.route_url"
                      :disabled="isDisable"></el-input>
          </el-form-item>

          <el-form-item label="图标:"
                        class="icon_img"
                        prop="icon">
            <!-- <el-input v-model="reportEditorForm.icon_img"></el-input> -->
            <el-upload list-type="picture-card"
                       :disabled="isDisable"
                       :action="uploadUrl"
                       :show-file-list="false"
                       name="image"
                       accept=".png,.jpeg,.jpg"
                       ref="iconImgRef"
                       :headers="uploadHeaders"
                       :data="uploadExtraData"
                       :on-success="handleAvatarSuccess"
                       :before-upload="beforeUpload">
              <img v-if="reportEditorForm.icon"
                   :src="reportEditorForm.icon" />
              <div v-else
                   class="icon-box">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <p>图片建议尺寸为327*267，圆角为24</p>
              </div>
            </el-upload>
          </el-form-item>

          <el-form-item class="btn-box">
            <el-button type="primary"
                       :disabled="isDisable"
                       @click="submitForm('reportEditorFormRef')">保存</el-button>
            <el-button @click="resetForm('reportEditorFormRef')"
                       :disabled="isDisable">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import imgtext from '../../../../api/imgtext';
import constant from '@/service/common/constant';
export default {
  data() {
    return {
      reportEditorForm: {
        report_name: '',
        type: '',
        route_url: '',
        icon_img: '',
        icon: ''
      },
      uploadExtraData: {
        img_type: 4,
        suffix: '.jpg'
      },
      rules: {
        report_name: [
          { required: true, message: '请输入报表名称', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        route_url: [
          { required: true, message: '请输入路由名称', trigger: 'change' }
        ],
        type: [{ required: true, message: '请选择类别', trigger: 'change' }],
        icon: [{ required: true, message: '请上传图标', trigger: 'blur' }]
      },
      dialogIcon: false
    };
  },
  filters: {
    titleText(val) {
      switch (val) {
        case '0':
          return '添加报表';
        case '1':
          return '编辑报表';
      }
    }
  },
  computed: {
    reportRoute() {
      return this.$route.query;
    },
    isDisable() {
      return this.$route.query.status == 2 ? true : false;
    },
    uploadUrl() {
      if (process.env.NODE_ENV == 'development') {
        // 本地开发使用 api 前缀
        return '/api/platform/upload/uploadFile';
      } else {
        return '/platform/upload/uploadFile';
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ['version', 'platform', 'appid']),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken
        }
      );
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.reportRoute.report_id != 0) {
        this.reportEditorForm = this.reportRoute;
        // console.log(this.reportEditorForm);
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = Object.assign(this.reportRoute, this.reportEditorForm);
          imgtext.saveReportInfo(params).then((res) => {
            let { code } = res;
            if (code == 0) {
              this.$message.success('保存成功');
              this.back();
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 上传成功
    handleAvatarSuccess(res, file, fileList) {
      let { code, data } = res;
      if (code === 0) {
        this.reportEditorForm.icon = data.path;
        this.reportEditorForm.icon_img = data.pic;
      }
    },
    // 上传之前
    beforeUpload(file) {
      const supportImgTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      const isSupportType = _.indexOf(supportImgTypes, file.type) !== -1;
      if (!isSupportType) {
        this.$message.error('上传图片只能是 jpg, png, jpeg 格式!');
        return false;
      }
      const suffix = file.name.substring(file.name.lastIndexOf('.'));
      this.uploadExtraData.suffix = suffix;
      this.uploadHeaders.timestamp = Date.now();
      const _this = this;
      return new Promise((resolve) => {
        const reader = new FileReader();
        const image = new Image();
        image.onload = (imageEvent) => {
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          const width = 327;
          const height = 267;
          canvas.width = width;
          canvas.height = height;
          context.clearRect(0, 0, width, height);
          context.drawImage(image, 0, 0, width, height);
          const dataUrl = canvas.toDataURL(file.type);
          const blobData = _this.dataURItoFile(dataUrl, file.name);
          resolve(blobData);
        };
        reader.onload = (e) => {
          image.src = e.target.result;
        };
        reader.readAsDataURL(file);
      });
    },
    dataURItoFile(dataurl, filename) {
      let arr = dataurl.split(',');
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    back() {
      history.back();
    }
  }
};
</script>

<style lang="scss" scoped>
.report-editor {
  .container {
    padding: 20px;
    border-radius: 5px;
    .report-box {
      min-height: calc(100vh - 120px);
      background: #fff;
      .report-reportEditorForm {
        padding: 20px;
        width: 600px;
        .report-type {
          ::v-deep .el-form-item__content {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .el-radio__label {
              font-size: 17px;
            }
          }
        }
        .btn-box {
          ::v-deep .el-form-item__content {
            display: flex;
          }
        }
      }
      .icon_img {
        ::v-deep .el-form-item__content {
          height: auto;
          display: flex;
          .icon-box {
            display: flex;
            flex-direction: column;
            p {
              height: 0;
            }
          }
          .el-upload--picture-card {
            width: 327px;
            height: 267px;
            border-radius: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: row;
          }
          .el-upload-list {
            & > li {
              width: 327px;
              height: 267px;
              border-radius: 24px;
            }
          }
        }
      }
    }
  }
}
</style>